import {
	Box,
	ButtonGroup,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { IconClipboardCheck } from '@tabler/icons';
import { AlertComponent } from 'components/alerts/AlertComponent';
import { ButtonComponent } from 'components/buttons/ButtonComponent';

interface IGeneratePlanConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const GeneratePlanConfirmationModal = (
	props: IGeneratePlanConfirmationModalProps
) => {
	const { isOpen, onClose, onConfirm } = props;

	const modalTitle = 'Gerar Plano';

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size={'4xl'}
			isCentered
		>
			<ModalOverlay />
			<ModalContent borderRadius={'3xl'}>
				<ModalHeader>
					<Icon
						as={IconClipboardCheck}
						color={'easyRED.300'}
						boxSize={14}
					/>
					<Text
						fontWeight={700}
						color={'easyBLUE.300'}
						fontSize={'2xl'}
					>
						{modalTitle}
					</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box mb={4}>
						<AlertComponent
							description={`A geração do Plano Restrito será processada em
							segundo plano. Você poderá continuar usando o
							sistema enquanto processamos os dados. Isso pode
							levar alguns minutos.`}
							status='info'
						/>
					</Box>
				</ModalBody>

				<ModalFooter>
					<ButtonGroup>
						<ButtonComponent
							type={'ghost'}
							title={'Cancelar'}
							onClick={onClose}
						/>
						<ButtonComponent
							type={'primary'}
							title={'OK, entendi e desejo prosseguir'}
							onClick={onConfirm}
						/>
					</ButtonGroup>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
